module.exports = __webpack_public_path__ + "img/2.fcab376a.jpg";